import styled from '@emotion/styled'

import { ButtonLink } from '@/components/Button'
import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

export const HeroWideContainer = styled(Container)`
  .hero-wide-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    padding: 1rem 1.5rem;

    ${CONFIG.media.sm} {
      gap: 2rem;
      padding: 1rem 2rem;
    }
  }
`

export const HeroImageContainer = styled.div`
  @media (min-width: 700px) and (max-height: 960px) {
    width: 480px;
  }
`

export const HeroButtonLink = styled(ButtonLink)`
  max-width: 24rem;
  width: 100%;

  background-color: rgb(var(--colors-pink));
  transition: ease-in-out all 0.2s;

  :hover {
    background-color: rgb(var(--colors-pink));
    filter: brightness(0.9);
  }

  :focus {
    background-color: rgb(var(--colors-pink));
    filter: brightness(1.2);
  }
`
